import { useEffect } from "react";
import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";
import { toast } from "sonner";
import { ContractForm } from "@/features/contracts/ContractForm";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const EDITOR_ROLES = new Set(["super_admin", "biomed_head", "facility_manager", "purchase_stores"]);

export const Route = createFileRoute("/_authenticated/contracts/$contractId/edit")({
  component: EditContractPage,
});

function EditContractPage() {
  const { contractId } = useParams({ from: "/_authenticated/contracts/$contractId/edit" });
  const navigate = useNavigate();
  const { data: me } = useCurrentUser();
  const canEdit = (me?.roles ?? []).some((r) => EDITOR_ROLES.has(r));

  useEffect(() => {
    if (me && !canEdit) {
      toast.info("Finance users can view contracts but cannot create or edit contracts.");
      navigate({ to: "/contracts/$contractId", params: { contractId }, replace: true });
    }
  }, [me, canEdit, contractId, navigate]);

  if (!me || !canEdit) return null;
  return <ContractForm contractId={contractId} />;
}
